import type { OperationCategoryChanged } from '../../model/bank-operation.js';
import type { ChangedOperationCategoryDto } from '../dto/bank-operation.dto.js';

export const toOperationCategoryChanged = (
  dto: ChangedOperationCategoryDto,
): OperationCategoryChanged => ({
  changedCount: dto.changedCount,
});
